import { ORIGIN } from '../const';

export const getBranchPermissionsPageURL = (repoPath = ''): string => {
  return `${ORIGIN}/${repoPath}/admin/branch-permissions`;
};

export const getSettingsPageURL = (
  repoPath: string,
  addonKey: string
): string => {
  return `${ORIGIN}/${repoPath}/admin/addon/admin/${addonKey}/settings`;
};

export const getForkPageURL = (repoPath: string): string => {
  return `${ORIGIN}/${repoPath}/fork`;
};
